import type { DialogKeys, FolderDialogContext } from './types';

import i18n from 'src/locales/i18n';
import { dispatch } from 'src/state';
import * as ActionTypes from 'src/state/action-types';
import { updateUserSettings } from 'src/state/user/actions';

export type DialogContext =
  | string
  | { contentId: string; contentType?: 'h5p' | 'worksheet' }
  | FolderDialogContext;

export function resetErrors() {
  return {
    type: ActionTypes.UI_RESET_ERRORS,
  };
}

export function changeLanguage(language: string) {
  i18n.changeLanguage(language);
  document.cookie = `language=${language}; path=/;SameSite=Lax;domain=${window.location.hostname === 'localhost' ? 'localhost' : '.lumi.education'}`;
  return {
    type: ActionTypes.UI_CHANGE_LANGUAGE,
    payload: language,
  };
}

export function showDialog(key: DialogKeys, context?: DialogContext) {
  return {
    type: ActionTypes.UI_SHOW_DIALOG,
    payload: { key, context },
  };
}

export function hideDialog(key: DialogKeys) {
  return {
    type: ActionTypes.UI_HIDE_DIALOG,
    payload: { key },
  };
}

export function navigate(path: string) {
  return {
    type: ActionTypes.UI_NAVIGATE,
    payload: { path },
  };
}

export function setView(view: 'grid' | 'list') {
  return async () => {
    dispatch(updateUserSettings({ folderView: view }));
  };
}

export function clipboardCut(folderId: string) {
  return {
    type: ActionTypes.UI_CLIPBOARD_CUT,
    payload: {
      cutFromFolderId: folderId,
    },
  };
}
